import OrganisationsSaga from "./saga";
import OrganisationsTableReducer from "./reducers/OrganisationsTableReducer";

import IConfig from "interfaces/IConfig";
import store from "rootStore";
import { permissionsType, routingType } from "types/configTypes";
import AsyncComponent from "ui/AsyncComponent";

export const moduleName = "Inventory.organisations";
export const url = "organsations";

const getConfig = (permissions: permissionsType, parentUrl: string) => {
    const config: IConfig = {
        active: false,
        routing: [],
        url,
    };

    let routing: routingType = [];

    if (permissions["inventory.organisations.read"]) {
        config.active = true;

        store.reducerManager?.add(
            "InventoryOrganisationTable",
            OrganisationsTableReducer
        );
        store.injectSaga?.("OrganisationsSaga", OrganisationsSaga);
        routing.push({
            path: url,
            element: (
                <AsyncComponent path="Inventory/Organisations/pages/OrganisationsIndexPage" />
            ),
        });
    }

    if (permissions["inventory.organisations.create"]) {
        routing.push({
            path: `${url}/create`,
            element: (
                <AsyncComponent path="Inventory/Organisations/pages/OrganisationsCreatePage" />
            ),
        });
    }
    if (permissions["inventory.organisations.update"]) {
        routing.push({
            path: `${url}/:id/edit`,
            element: (
                <AsyncComponent path="Inventory/Organisations/pages/OrganisationsEditPage" />
            ),
        });
    }

    if (routing.length > 0) {
        config.routing = routing.map((item) => parentUrl + "/" + item.path);
    }

    return { config, routing };
};

export default getConfig;
